'use client';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

import NotFound from '@/public/icons/404.svg';

const PcNotFound = () => {
  const t = useTranslations('404');

  const router = useRouter();

  return (
    <section className="mx-auto w-max h-screen flex flex-col justify-center">
      <figure className="w-[577px] h-[260px] mb-[16px]">
        <NotFound width="100%" height="100%" viewBox="0 0 201 68" />
      </figure>
      <p className="text-[42px] font-semibold leading-[52px] text-center mb-[8px]">{t('title')}</p>
      <p className="text[18px] leading-[28px] font-normal text-center text-[#434343] mb-[40px]">
        {t('description')}
      </p>
      <button
        className="bg-[#004EFF] w-max py-[16px] px-[24px] rounded-[40px] text-white text-[18px] leading-[28px] flex mx-auto"
        onClick={router.back}
      >
        {t('button')}
      </button>
    </section>
  );
};

export default PcNotFound;
